import { useEffect, useState } from "react"
import { FeaturedProject } from "config"
import {
  ArtBlocksProjectMetadata,
  fetchFeaturedProjectMetadata,
} from "utils/artBlocksMetadataApi"

const useArtBlocksProjectMetadata = (project: FeaturedProject) => {
  const [data, setData] = useState<ArtBlocksProjectMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(false)

    fetchFeaturedProjectMetadata(project)
      .then((projectMetadata) => {
        if (!cancelled) setData(projectMetadata || null)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [project])

  return { data, loading, error }
}

export default useArtBlocksProjectMetadata
